import { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export function GraphPlot(){
  const [text1,setText1]=useState(JSON.stringify([{x:18,y:20,z:0},{x:19,y:22,z:0},{x:20,y:24,z:0},{x:21,y:28,z:0},{x:22,y:50,z:1},{x:23,y:35,z:0},{x:24,y:30,z:0},{x:25,y:32,z:1},{x:26,y:35,z:0},{x:27,y:37,z:0},{x:28,y:80,z:1},{x:29,y:40,z:0},{x:30,y:45,z:0},{x:31,y:50,z:0},{x:32,y:45,z:0},{x:33,y:47,z:0},{x:34,y:46,z:0},{x:35,y:56,z:1},{x:36,y:60,z:1},{x:37,y:23,z:0},{x:38,y:53,z:1},{x:39,y:30,z:0},{x:40,y:60,z:1},{x:41,y:63,z:1},{x:42,y:45,z:0},{x:43,y:52,z:1},{x:44,y:51,z:1},{x:45,y:60,z:1},{x:46,y:22,z:0},{x:47,y:55,z:1},{x:48,y:53,z:1},{x:50,y:45,z:1},{x:52,y:65,z:1},{x:54,y:78,z:1},{x:55,y:78,z:1},{x:56,y:45,z:1},{x:57,y:56,z:1},{x:58,y:80,z:1},{x:59,y:90,z:1},{x:60,y:95,z:1}]))
  const [data,setData]=useState({
    "x-label":[0,5,10,15,20,25],
    "y-label":[15,10,5,0],
    "max":25,
    item:[]
  })
  function trimdata(x){
    const a1=x.map(x1=>x1.x).sort(function(a, b) {return a-b})
    const a2=x.map(x1=>x1.y).sort(function(a, b) {return a-b})
    const xunit=150/(a1[a1.length-1]-a1[0])
    const yunit=100/(a2[a2.length-1]-a2[0])
    const templateData={
      "x-label":[0,5,10,15,20,25],
      "y-label":[15,10,5,0],
      "max":25,
      item:[]
    }
    templateData['x-label']=[a1[0],Math.floor(a1[0]+((a1[a1.length-1]-a1[0])/6)),Math.floor(a1[0]+((a1[a1.length-1]-a1[0])/6)*2),Math.floor(a1[0]+((a1[a1.length-1]-a1[0])/6)*3),Math.floor(a2[0]+((a2[a2.length-1]-a2[0])/6)*4),a2[a2.length-1]]
    templateData['y-label']=[a2[a2.length-1],Math.floor(a2[0]+((a2[a2.length-1]-a2[0])/4)*2),Math.floor(a2[0]+((a2[a2.length-1]-a2[0])/4)),a2[0]]
    for(let i=0; i<x.length;i++){templateData.item.push({x:(x[i].x-a1[0])*xunit,y:(x[i].y-a2[0])*yunit,z:x[i].z})}
    setData(templateData)
  }
  if(data.item.length==0){trimdata(JSON.parse(text1))}
  const onClick2Apply=()=>{trimdata(JSON.parse(text1))}
  return (
    <div className='grid grid-cols-1 md:grid-cols-[250px_auto] h-fit'>
      {data.item.length!==0? 
      <div className='flex'>
        <div className='ml-[20px] relative h-[98px] flex flex-col justify-between'>
        {data['y-label'].map((x)=><div className='relative border-b border-gray-800 w-[3px] ml-auto'>
          <div className='absolute z-[2] text-[6px] top-[-4px] right-[4px]'>{x}</div> 
        </div> 
        )}
        <div className='absolute z-[1] w-fit left-[-24px] top-[45%] flex justify-between text-[6px]'>age</div>
        <div className='absolute z-[1] w-fit left-[50px] top-[110px] flex justify-between text-[6px]'>salary(USDK/year)</div>
        </div> 
        <div>
        <div className='relative'>
        <div className='absolute z-[0] top-[0px] w-[150px] h-[98px] flex flex-col justify-between'>
         {data['y-label'].map((x,i)=><>{i==data['y-label'].length-1?<div className='w-full border-t border-gray-200'></div>:<><div className='w-full border-t border-gray-200'></div>
        <div className='w-full border-t border-gray-100'></div>
        <div className='w-full border-t border-gray-100'></div>
        <div className='w-full border-t border-gray-100'></div>
        <div className='w-full border-t border-gray-100'></div> 
        </>}</>)}
        </div>
        <div className='absolute z-[1] w-[150px] h-[98px] flex justify-between'>
        {data['x-label'].map((x,i)=><>{i==data['x-label'].length-1?<div className='h-full border-r border-gray-200'></div>:<><div className='h-full border-r border-gray-200'></div>
        <div className='h-full border-r border-gray-100'></div>
        <div className='h-full border-r border-gray-100'></div>
        <div className='h-full border-r border-gray-100'></div>
        <div className='h-full border-r border-gray-100'></div> 
        </>}</>)}
        </div>
        <div className='absolute z-[2] w-[150px] h-[98px] flex justify-between'>
        <div className='relative z-[3] w-[150px] h-[97px]'>
        {data.item.map((x)=><div style={{left:`${(x.x)-2.5}px`,bottom:`${(x.y)-4.5}px`}} className={`absolute z-[3] rounded-full  w-[4px] h-[4px] ${x.z==0?'bg-blue-800':'bg-red-800'}`}></div>)}
        <div className='border-l border-gray-800 h-full'></div>
        <div className='relative border-t border-gray-800 h-1 w-full'>
        <div className='absolute flex w-full justify-between'>{data['x-label'].map((x)=>
        <div className='relative border-l border-gray-800 h-[2px]'> 
        <div className='absolute text-[6px] top-[2px] left-[-4px]'>{x}</div>
        </div>
        )}</div>
        </div>
        </div>
        </div>
        </div>
        </div>
      </div>
      :<div className='text-[9px]'>loading...</div>}
      <div className='flex flex-col mt-[20px] md:mt-[-20px] text-[9px]'>
      <p className='text-[9px]'>json data:</p>
      <textarea className='text-input-width border border-gray-950 text-[9px] w-[150px] h-[70px] line-break' value={text1} placeholder='your data goes here' onChange={(e)=>setText1(e.target.value)} rows='4'></textarea>
      <button className='border border-gray-800 text-[9px] w-fit pl-[10px] pr-[10px] mt-[2px] hover:bg-gray-100' onClick={onClick2Apply}>apply</button></div>
    </div>
  )
}
export default function MlPurchase() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [res, setRes]= useState('')
    const [userInput, setUserInput] = useState({age:28,salary:680})
    const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value }) }
    const onClick2PurchaseRate=async()=>{
        setLoadingMsg(true)
        try {
            const {data:res} = await axios.post(`${APIURL}/ml/purchase`,userInput)
            setRes(res.result)
            setLoadingMsg(false)
        } catch (err) {
            console.log(err)
        }
    }
    return (
    <div className='text-left m-2'>
    <div className='text-[9px] font-bold mb-[8px]'>Step1 Graph with plot all the items</div>
    <GraphPlot/>
    <div className='text-[9px] font-bold  mt-[24px]'>Step2 Graph with plot all the items</div>
    <div className='grid grid-cols-1 md:grid-cols-[250px_auto]'>
    <div className='mt-[2px] flex'>
    <div className='flex h-fit'>
    <div className='flex flex-col'> 
    <label className='text-[9px]'>age</label>
    <input className='text-right pr-1 pl-1 w-20 md:w-8 mr-[2px] border border-gray-800' name='age' type='text' defaultValue='28' onChange={onChange2Input}/>
    </div>
    <div className='flex flex-col w-fit'>
    <label className='text-[9px]'>salary(USDK/year)</label>
    <input className='text-right pr-1 pl-1 w-20 md:w-20 mr-[2px] border border-gray-800' name='salary' type='text' defaultValue='68' onChange={onChange2Input}/>
    </div>
    <button className='bg-gray-800 hover:bg-gray-700 mt-auto h-[26px] pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2PurchaseRate}>Calculate</button>
    </div>
    </div>
    <div className='flex-col'>
    <p className='text-[9px]'>csv data:<br/>
    40items 87.5%, 1555items 98.7% accuracy level.</p>
    <div  className='text-[9px] bg-gray-100 w-fit h-fit p-1 mb-1'>
    Age,Salary,Purchased<br/>
    35,200,1<br/>
    32,60,0<br/>
    ... 
    </div>
    </div>
    </div>
    <div className='text-[12px]'>
    <b>ML Result:</b><br/>
    <div className='text-left'>
    {loadingMsg?<p className='flex text-xs'>Please wait for a moment<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:<>{res==''? <span className='text-gray-400'>Click Calculate to see the result</span>:<>{res}</>}</>}
    </div>
    </div>
    </div>
  )
}